import request from '@/utils/request'

export function featchComments(params) {
    return request({
        url: '/blog/index/article/comment',
        method: 'get',
        params: params
    })
}
export function getMyComment(params) {
    return request({
        url: '/v1/comment/getMyComment',
        method: 'get',
        params: params
    })
}
export function newArticle() {
    return request({
        url: '/v1/upToDateArticle',
        method: 'get',
    })
}

export function postComment(data) {
    return request({
        url: '/blog/index/article/comment/save',
        method: 'post',
        data
    })
}
